export const isCompulsoryProduct = (product) =>
  product?.is_compulsory === '1' ||
  product?.is_compulsory === 1 ||
  product?.is_compulsory === true;

export function resolveCompulsoryMinQuantity(product, tabType = 'buy') {
  if (!isCompulsoryProduct(product)) return 0;
  const compReq = parseInt(product?.compulsory_quantity, 10);
  if (tabType === 'get') {
    return compReq > 0 ? compReq : 0;
  }
  return compReq > 0 ? compReq : 1;
}

export function getMissingCompulsoryProductCodes(
  promotionDetails,
  productQuantities,
  existingCartQuantities
) {
  const effectiveQty = (tabType, productId) => {
    const prefix = `${tabType}_${String(productId)}_`;
    const keys = new Set([
      ...Object.keys(productQuantities || {}),
      ...Object.keys(existingCartQuantities || {}),
    ]);
    let total = 0;
    keys.forEach((key) => {
      if (!key.startsWith(prefix)) return;
      const existing = existingCartQuantities[key] || 0;
      const ui = productQuantities[key];
      const eff = ui !== undefined && ui !== null ? Number(ui) : existing;
      total += eff;
    });
    return total;
  };

  const codes = [];
  const seen = new Set();

  (promotionDetails?.buy_products || []).forEach((p) => {
    if (!isCompulsoryProduct(p)) return;
    const required = resolveCompulsoryMinQuantity(p, 'buy');
    if (effectiveQty('buy', p.product_id) < required) {
      const c = String(p?.product_code || '').trim() || String(p.product_id);
      if (!seen.has(c)) {
        seen.add(c);
        codes.push(c);
      }
    }
  });

  return codes;
}
